// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mXgL","colMin":"styles_colMin__2iBxI"};